// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","linkContainer":"_3hjJa","title":"_2kN8m","subtitle":"_1A6sQ","ctaContainer":"_3Nwuc","label":"_2gXWf"};